import { useState, useCallback, useEffect } from 'react'

import { Article } from './types'

const SECTION_MAP = {
  SDK: 360006873052,
  API: 360006873072,
}

export const useFAQArticles = () => {
  const [articles, setArticles] = useState<Article[]>([])
  const [searchQuery, setSearchQuery] = useState('')
  const [filtering, setFiltering] = useState<'SDK' | 'API'>('SDK')

  const onSearchInput = useCallback((query: string) => setSearchQuery(query), [])

  const performSearch = useCallback(
    async () => {
      const SECTION_ID = SECTION_MAP[filtering]
      const FETCH_URL = `https://support.giphy.com/api/v2/help_center/articles/search.json?snippet=true&section=${SECTION_ID}${
        searchQuery && `&query="${searchQuery}"`
      }`

      const data = await fetch(FETCH_URL).then((response) =>
        response.json ? response.json() : response
      )

      if (!data || !data.results) return

      setArticles(data.results.sort((a: Article, b: Article) => a.position - b.position))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchQuery, filtering, articles.length]
  )

  const onSortSelect = useCallback((value: 'SDK' | 'API') => setFiltering(value), [])

  useEffect(
    () => {
      performSearch()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filtering]
  )

  return {
    articles,
    searchQuery,
    onSearchInput,
    onSearch: performSearch,
    filtering,
    onSortSelect,
  }
}
